import { Mui } from "@osu/react-ui";
import { inputMappings } from "../../util/enums";
import { BOOL, EXAM_EVAL_COMMENTS_MAX_LENGTH } from "../../util/constants";

export const Summary = (props = {}) => {
  return (
    <Mui.Typography variant="body2" className="margin-bottom-2">
      Section 7.9 of the Graduate School Handbook outlines the role of the Graduate Faculty Representative (GRF) during the examination.
      The GFR should assess the examination process for its fairness and rigor, the integrity and professional behavior of the participants, 
      and its conformity to the rules of the Graduate School. The responses provided below should follow this, and the open-ended question allows 
      for additional comments regarding the examination. Please note that a grade of “Satisfactory” is representative of the examination process 
      and is not reflective of the student’s performance during the examination.
    </Mui.Typography>
  );
};
export const questions = [
  {
    id: "breadth-and-depth",
    type: inputMappings.radio,
    title: "Was the examination process fair to the student and sufficiently rigorous to constitute a scholarly defense of the dissertation?",
    required: true,
    dataField: "examinationEvaluation.breadthAndDepth",
    choices: [
      {
        id: "breadth-and-depth-no",
        title: "No",
        value: BOOL.NO
      },
      {
        id: "breadth-and-depth-yes",
        title: "Yes",
        value: BOOL.YES
      }
    ],
    validation: (form, value) => (value && [BOOL.NO, BOOL.YES].includes(value) ? null : "This field is required")
  },
  {
    id: "rules",
    type: inputMappings.radio,
    title: "Did all participants act with integrity and professionalism during the examination process?",
    required: true,
    dataField: "examinationEvaluation.rules",
    choices: [
      {
        id: "rules-no",
        title: "No",
        value: BOOL.NO
      },
      {
        id: "rules-yes",
        title: "Yes",
        value: BOOL.YES
      }
    ],
    validation: (form, value) => (value && [BOOL.NO, BOOL.YES].includes(value) ? null : "This field is required")
  },
  {
    id: "participants-action",
    type: inputMappings.radio,
    title: "Did the examination process conform to the rules of the Graduate School as outlined in Sections 7.9 and 7.10 of the Graduate School Handbook?",
    required: true,
    dataField: "examinationEvaluation.participantsAction",
    choices: [
      {
        id: "participants-action-no",
        title: "No",
        value: BOOL.NO
      },
      {
        id: "participants-action-yes",
        title: "Yes",
        value: BOOL.YES
      }
    ],
    validation: (form, value) => (value && [BOOL.NO, BOOL.YES].includes(value) ? null : "This field is required")
  },
  {
    id: "additional-comments",
    title: "Additional comments and feedback",
    dataField: "examinationEvaluation.additionalComments",
    type: inputMappings.textInput,
    required: true,
    multiline: true,
    rows: 4,
    inputProps: {
      maxLength: EXAM_EVAL_COMMENTS_MAX_LENGTH,
      style: {
        resize: "vertical"
      }
    },
    validation: (form, value) => {
      if(value) {
        if(value.length > EXAM_EVAL_COMMENTS_MAX_LENGTH) {
          return `This field is limited to ${EXAM_EVAL_COMMENTS_MAX_LENGTH} characters`;
        } else {
          return null;
        }
      } else {
        return "This field is required";
      }
    }
  }
];

export const formSections = [
  {
    id: "examination-evaluation",
    title: "Examination Evaluation",
    wrap: false,
    questions
  }
];